package com.milta.core.localization.translations.sq

import com.milta.core.localization.UnlocatedDeliveryStrings

internal val UnlocatedDelivery = UnlocatedDeliveryStrings(
    warningTitleSingular = "1 adresë e palokalizuar",
    warningTitlePlural = "%d adresa të palokalizuara",
    warningMessage = "Këto dërgesa nuk u vendosën dot në hartë. Korrigjoni adresën e tyre ose vazhdoni: do të vendosen në fund të turit.",
    fixAction = "Korrigjo",
    continueWithoutAction = "Vazhdo pa to",
    unplacedStopsSingular = "1 ndalesë e pavendosur, në fund të turit",
    unplacedStopsPlural = "%d ndalesa të pavendosura, në fund të turit",
    fixAddressAction = "Korrigjo adresën",
    unlocatedBadge = "E palokalizuar",
)
